// src/pages/SimpleLinkHubItem.jsx
import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { linkHubDropdown } from '../data/dummyData';
import './SimpleLinkHubItem.css';

const SimpleLinkHubItem = () => {
  const { linkId } = useParams();
  const [linkData, setLinkData] = useState(null);

  useEffect(() => {
    // Find the link data based on the path parameter
    const data = linkHubDropdown.find(link => 
      link.path === `/link-hub/${linkId}`
    );
    setLinkData(data);
  }, [linkId]);

  const handleExternalClick = (e) => {
    e.preventDefault();
    if (linkData) {
      window.open(linkData.url, '_blank', 'noopener,noreferrer');
    }
  };

  if (!linkData) {
    return (
      <div className="simple-link-page">
        <div className="simple-link-container">
          <div className="simple-not-found">
            <h2>Link Not Found</h2>
            <Link to="/" className="simple-back-btn">← Back to Home</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="simple-link-page">
      <div className="simple-link-container">
        <div className="simple-link-content">
          <h1 className="simple-link-title">{linkData.title}</h1>
          
          <div className="simple-link-message">
            <p className="simple-text">
              Click here to access{' '}
              <a 
                href={linkData.url} 
                onClick={handleExternalClick}
                className="simple-external-link"
              >
                {linkData.title}
              </a>
              .
            </p>
          </div>

          <div className="simple-link-actions">
            <Link to="/" className="simple-home-btn">
              ← Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimpleLinkHubItem;